import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, InputAdornment, TextField } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        marginTop: 18
    },
    inputRow: {
        display: 'flex',
        width: '100%',
        '&:not(:last-child)': { marginBottom: 20 }
    },
    inputContainer: {
        width: '100%',
        minWidth: 200,
        fontSize: '.93rem',
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3)
    },
    formControl: {
        maxWidth: 500,
        marginTop: 7,
        padding: 0,
        '& .MuiOutlinedInput-inputMarginDense': {
            fontSize: 12
        }
    }
}));

function FormInputs({ handleChange, values, validations }) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [showPassword, setShowPassword] = useState(false);
    const handleBlur = () => {
        let a = values.user_email.indexOf('@');
        values.user_name = values.user_email.slice(0, a);
    }
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    return (
        <form className={classes.container} noValidate autoComplete="off" data-test="forminputs-container">
            <div className={classes.inputRow}>
                <div className={classes.inputContainer}>
                    <div className="user-label">{t('CONTENT.USER.FIRST-NAME')}<span className='mandatory-field'>*</span> </div>
                    <TextField
                        data-test="firstname-input"
                        classes={{ root: classes.formControl }}
                        value={values.first_name}
                        onChange={(event) => { handleChange('first_name', event); }}
                        error={values.first_name.length > 0 && !validations.first_name}
                        margin="normal"
                        variant="outlined"
                        size="small"
                        fullWidth
                    />
                </div>
                <div className={classes.inputContainer}>
                    <div className="user-label">{t('CONTENT.USER.MIDDLE-NAME')}</div>
                    <TextField
                        data-test="secondname-input"
                        classes={{ root: classes.formControl }}
                        value={values.second_name}
                        onChange={(event) => { handleChange('second_name', event); }}
                        //error={values.second_name.length > 0 && !validations.second_name}
                        margin="normal"
                        variant="outlined"
                        size="small"
                        fullWidth
                    />
                </div>
                <div className={classes.inputContainer}>
                    <div className="user-label">{t('CONTENT.USER.LAST-NAME')}<span className='mandatory-field'>*</span> </div>
                    <TextField
                        data-test="lastname-input"
                        classes={{ root: classes.formControl }}
                        value={values.last_name}
                        onChange={(event) => { handleChange('last_name', event); }}
                        error={values.last_name.length > 0 && !validations.last_name}
                        margin="normal"
                        variant="outlined"
                        size="small"
                        fullWidth
                    />
                </div>
            </div>
            <div className={classes.inputRow}>
                <div className={classes.inputContainer}>
                    <div className="user-label">{t('CONTENT.USER.USERNAME')}</div>
                    <TextField
                        data-test="username-input"
                        classes={{ root: classes.formControl }}
                        error={values.user_name.length > 0 && !validations.user_name}
                        helperText={values.user_name.length > 5 && !validations.user_name ? t('CONTENT.USER.USERNAME-NOT-VALID') : null}
                        value={values.user_name} disabled
                        margin="normal"
                        variant="outlined"
                        size="small"
                        fullWidth
                    />
                </div>
                <div className={classes.inputContainer}>
                    <div className="user-label">{t('CONTENT.USER.E-MAIL')}<span className='mandatory-field'>*</span> </div>
                    <TextField
                        data-test="email-input"
                        classes={{ root: classes.formControl }}
                        onChange={(event) => { handleChange('user_email', event); }}
                        error={values.user_email.length > 0 && !validations.user_email}
                        helperText={document.querySelector(".email-textField > div")?.classList.length <= 7 && values.user_email.length > 0 && !validations.user_email ? t('CONTENT.USER.EMAIL-NOT-VALID') : null}
                        value={values.user_email}
                        onBlur={handleBlur}
                        type="email"
                        autoComplete="email"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        fullWidth
                        className='email-textField'
                    />
                </div>
                <div className={classes.inputContainer}>
                    <div className="user-label">{t('CONTENT.USER.CONFIRM-EMAIL')}<span className='mandatory-field'>*</span></div>
                    <TextField
                        data-test="confirmemail-input"
                        classes={{ root: classes.formControl }}
                        onChange={(event) => { handleChange('confirmEmail', event); }}
                        value={values.confirmEmail}
                        error={values.confirmEmail.length > 0 && !validations.confirmEmail}
                        helperText={((values.confirmEmail.length >= values.user_email.length && values.confirmEmail !== values.user_email)) && !validations.confirmEmail ? t('CONTENT.USER.EMAIL-NOT-SAME') : null}
                        autoComplete=""
                        margin="normal"
                        variant="outlined"
                        size="small"
                        fullWidth
                        className='confirm-email-textField'
                    />
                </div>
            </div>
            <div className={classes.inputRow}>
                <div className={classes.inputContainer} style={{ flexDirection: 'row' }}>
                    <div className="user-label">{t('CONTENT.USER.PASSWORD')}<span className='mandatory-field'>*</span> </div>
                    <TextField
                        data-test="password-input"
                        classes={{ root: classes.formControl }}
                        onChange={(event) => { handleChange('user_password', event); }}
                        value={values['user_password']}
                        error={values['user_password'].length > 0 && !validations['user_password']}
                        onFocus={() => { const hints = document.getElementById("message"); hints.style.display = "block"; }}
                        onBlur={() => { const hints = document.getElementById("message"); setTimeout(() => { hints.style.display = "none"; }, 250); }}
                        type={showPassword ? 'text' : 'password'}
                        autoComplete="current-password"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        InputProps={{
                            endAdornment:
                                <InputAdornment position="end">
                                    <IconButton size="small" onClick={handleClickShowPassword}>
                                        {showPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                    </IconButton>
                                </InputAdornment>
                        }}
                        fullWidth
                    />
                    <div id="message">
                        <p><b>{t('CONTENT.USER.PASSWORD-MUST-CONTAIN')}</b></p>
                        <p id="letter" className="invalid">{t('CONTENT.USER.PASSWORD-LOWERCASE')}</p>
                        <p id="capital" className="invalid">{t('CONTENT.USER.PASSWORD-UPPERCASE')}</p>
                        <p id="number" className="invalid">{t('CONTENT.USER.PASSWORD-NUMBER')}</p>
                        <p id="length" className="invalid">{t('CONTENT.USER.PASSWORD-LENGTH')}</p>
                        <p id="special" className="invalid">{t('CONTENT.USER.PASSWORD-SPECIAL')}</p>
                    </div>
                </div>
                <div className={classes.inputContainer}>
                    <div className="user-label">{t('CONTENT.USER.CONFIRM-PASSWORD')}<span className='mandatory-field'>*</span> </div>
                    <TextField
                        data-test="confirmpassword-input"
                        classes={{ root: classes.formControl }}
                        onChange={(event) => { handleChange('user_password_retry', event); }}
                        value={values['user_password_retry']}
                        error={values['user_password_retry'].length > 0 && !validations['user_password_retry']}
                        helperText={(values['user_password_retry'].length > values['user_password'].length) && !validations['user_password_retry'] ? t('CONTENT.USER.PASSWORD-NOT-SAME') : null}
                        type="password"
                        autoComplete=""
                        margin="normal"
                        variant="outlined"
                        size="small"
                        fullWidth
                    />
                </div>
                <div className={classes.inputContainer}></div>
            </div>
        </form>
    );
}

export default FormInputs;
